






















































































import {
	computed,
	defineComponent,
	reactive,
	toRef,
	watch,
} from '@vue/composition-api';
import deepEqual from 'deep-equal';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import TrModal from '@front-app/components/modals/TrModal.vue';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { isEmptyHighlights } from '@front-app/modules/group/highlights/util/compare';
import { GroupAuditAction } from '@front-app/services/ActionApi/ActionModel';
import { COMPONENTS_BY_TYPE, SECTIONS_BY_TYPE } from '@front-app/modules/group/highlights/util/componentsByType';
import {
	AnyHighlightComponent,
	ElementType,
	HighlightsButtonAction,
	HighlightsButtonComponent,
} from '@front-app/modules/group/highlights/model';
import { trackGroupSimpleAction } from '@front-app/services/ActionApi/ActionApi';
import { useGroupCustomPage } from '@front-app/store/modules/highlights';
import { useIsLoading } from '@front-app/hooks/useAsyncStatus';

type ModalButton = HighlightsButtonAction.VIEW_EXTERNAL_VIDEO
	| HighlightsButtonAction.REFER_COLLEAGUE_TO_GROUP
	| HighlightsButtonAction.SUBMIT_SUGGESTION
	| HighlightsButtonAction.START_QUIZ;

const MODAL_BUTTONS = [
	HighlightsButtonAction.VIEW_EXTERNAL_VIDEO,
	HighlightsButtonAction.REFER_COLLEAGUE_TO_GROUP,
	HighlightsButtonAction.SUBMIT_SUGGESTION,
	HighlightsButtonAction.START_QUIZ,
];

const isModalButton = (item: HighlightsButtonAction): item is ModalButton => MODAL_BUTTONS.includes(item);

const MODAL_TITLES: Record<ModalButton, string> = {
	[HighlightsButtonAction.VIEW_EXTERNAL_VIDEO]: 'Watch video',
	[HighlightsButtonAction.REFER_COLLEAGUE_TO_GROUP]: 'Refer a colleague to the group',
	[HighlightsButtonAction.SUBMIT_SUGGESTION]: 'Submit a suggestions',
	[HighlightsButtonAction.START_QUIZ]: 'Take a quiz',
};

export default defineComponent({
	components: {
		PaddedContent,
		TrModal,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const trackActionProps = computed(() => props.groupId);

		watch(trackActionProps, (curr, prev) => {
			if (deepEqual(curr, prev) || !props.groupId) {
				return;
			}
			trackGroupSimpleAction(props.groupId, GroupAuditAction.VIEW_CUSTOM_PAGE);
		}, { immediate: true });

		const {
			highlights,
			status: customPageFetchStatus,
		} = useGroupCustomPage(computed(() => props.groupId));
		const isLoadingCustomPage = useIsLoading(customPageFetchStatus);
		const isCustomPageEmpty = computed(() => isEmptyHighlights(highlights.value));

		const handleClick = (item: AnyHighlightComponent) => {
			switch (item.type) {
			case ElementType.BUTTON:
				handleButtonClick(item);
				break;
			default:
				// do nothing
			}
		};
		const modal = reactive({
			isVisible: false,
			href: '',
			title: '',
		});
		function handleButtonClick({ meta }: HighlightsButtonComponent) {
			if (!isModalButton(meta.action)) {
				return;
			}
			if (!meta.href) {
				return;
			}
			modal.isVisible = true;
			modal.href = meta.href;
			modal.title = MODAL_TITLES[meta.action];
		}
		function closeModal() {
			modal.isVisible = false;
			modal.href = '';
			modal.title = '';
		}
		return {
			group,
			isLoadingCustomPage,
			isCustomPageEmpty,
			highlights,
			isModalVisible: toRef(modal, 'isVisible'),
			modalHref: toRef(modal, 'href'),
			modalTitle: toRef(modal, 'title'),
			handleClick,
			closeModal,
			COMPONENTS_BY_TYPE,
			SECTIONS_BY_TYPE,
		};
	},
});
